import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'split-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
})
export class StepComponent {
  @Input() public passo: number = 0;
  @Input() public ignoreStep: boolean = false;
  @Input() public label!: string;
  @ViewChild(TemplateRef) template!: TemplateRef<any>;
}
